export default __webpack_public_path__ + "static/media/rarity-uncommon.df7f70d0.svg";